import { UPDATE_USER_LOCATION } from "./userLocationReducer"

export const updateUserLocation = (position) => async (dispatch) => {
    dispatch({
        type: UPDATE_USER_LOCATION,
        payload: position
    })
}